const mode = 'PROD';

export const API_BASE_URL =
    mode === 'DEV'
        ? 'http://localhost/melocalizae/src/php'
        : 'https://melocalizae.com.br/php';


let sessionId = localStorage.getItem('session_id');
/*LOGS*/
export const registrarLog = async (pagina, acao, consulta_relatorio) => {
    // Recupera ou cria uma sessão única no dispositivo do usuário

    if (!sessionId) {
        sessionId = crypto.randomUUID();
        localStorage.setItem('session_id', sessionId);
    }

    const response = await fetch(API_BASE_URL + '/events/events-register.php', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            pagina: pagina,
            acao: acao,
            data_hora: new Date().toISOString(),
            session_id: sessionId,
            consulta_relatorio: consulta_relatorio
        }),
    });
    const data = await response.json();
    console.log(data);
}



export const enviarTempo = (pagina, inicio, consulta_relatorio) => {
    const tempoMs = Date.now() - inicio;

    const tempoSegundos =
        Math.floor(tempoMs / 1000);

    navigator.sendBeacon(
        API_BASE_URL + '/logs/registro-logs.php',
        JSON.stringify({
            pagina: pagina,
            acao: tempoSegundos,
            session_id: sessionId,
            consulta_relatorio: consulta_relatorio
        })
    );
};


